import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Spinner } from 'src/app/core/services/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { TicketRequest } from 'src/app/shared/model/ticket-access-request.model';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { Location } from '@angular/common';
import { RenTM } from 'src/app/shared/model/renTM.model';
import { SubscriptionLike } from 'rxjs';
import { RenTMService } from 'src/app/shared/service/ren-tm.service';
import { FormArray } from '@angular/forms';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-renTM-form',
  templateUrl: './renTM-form.component.html',
  styleUrls: ['./renTM-form.component.scss']
})
export class RenTMFormComponent implements OnInit, OnDestroy {
  RenTM: RenTM = new RenTM();
  RenTMForm: FormGroup;
  CustomSubForm: FormArray;
  request: TicketRequest[] = [];
  isSpin: boolean;
  checkSubmit: boolean;
  color = 'primary';
  subtasks = [
    {name: 'Carrier', value: false},
    {name: 'Rail', value: false},
    {name: 'Vessel', value: false},
    {name: 'River barges', value: false},
    {name: 'Survey', value: false},
    {name: 'Storage & port', value: false},
    {name: 'Customs broker', value: false}
  ];
  items = []
  subscription: SubscriptionLike;

  constructor(
    private spinner: Spinner,
    private location: Location,
    private fb: FormBuilder,
    private toastService: ToastrService,
    private dialog: MatDialog,
    private service: RenTMService
  ) { }

  ngOnInit(): void {
    this.initFormRenTM();
    this.getListTicket();
  }

  getListTicket(event?) {
    if (event) {
      event.srcElement.classList.remove('rotate');
      setTimeout(() => {
        event.srcElement.classList.add('rotate');
      }, 0);
    }
    this.subscription = this.service.getRequestRenTMAccessList().subscribe((res) => {
      this.request = res.data;
    }, (err) => {
    });
  }

  initFormRenTM() {
    this.RenTMForm = this.fb.group({
      firstName: [this.RenTM.firstName || '', [Validators.required]],
      lastName: [this.RenTM.lastName || '', [Validators.required]],
      email: [this.RenTM.email || '', [Validators.required]],
      mobilePhone: [this.RenTM.mobilePhone || '', [Validators.required]],
      companyName: [this.RenTM.companyName || '', [Validators.required]],
      officePhone: [this.RenTM.officePhone || ''],
      ssoID: [this.RenTM.ssoID || '', [Validators.required]],
      region: [this.RenTM.region || '', [Validators.required]],
      suppliers: [false],
      lsp: [false],
      access: this.fb.array(this.subtasks.map((item) => this.initAccessForm(item))),
    });
    this.CustomSubForm = this.fb.array(
      this.items.map(i => this.initAccessForm(i))
    )
  }

  ngOnDestroy() {
    // unsubscribe
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  initAccessForm(item) {
    return this.fb.group({
      name: [item.name],
      value: [item.value],
    });
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  submitRenTMForm(): void {
    if (this.checkSubmit) {
      this.setErrorForm(this.RenTMForm);
    }
    if (!this.RenTMForm.valid) {
      this.markFormGroupTouched(this.RenTMForm);
      return;
    } else {
      this.openDialog();
    }
  }

  goToApplication() {
    window.open('https://rentm-ren.apps.ge.com/');
  }

  getInitFormByID(id) {
    this.spinner.show();
    this.service.getRequestRenTMAccess(id).subscribe((res) => {
      this.spinner.hide();
      this.RenTM = new RenTM(res.data);
      this.initFormRenTM();
    });
  }

  openDialog() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_REQUEST_ACCESS,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        const body = new RenTM({ ...this.RenTMForm.getRawValue(), ...{ items: this.CustomSubForm.getRawValue()}}, false).convertToReqBody();
        this.spinner.show();
        this.service.requestRenTMAccess(body).subscribe((res) => {
          this.spinner.hide();
          this.toastService.success(MESSAGE_TOAST.REQUEST_ACCESS_TICKET_SUCCESS);
          setTimeout(() => {
            location.reload();
          }, 1000);
        });
      }
    });
  }

  resetForm(formGroup: FormGroup) {
    let control: AbstractControl = null;
    formGroup.reset();
    formGroup.markAsUntouched();
    Object.keys(formGroup.controls).forEach((name) => {
      control = formGroup.controls[name];
      control.setErrors(null);
    });
    formGroup.setErrors({ invalid: true });
    this.checkSubmit = true;
  }

  setErrorForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((name) => {
      if (!formGroup.controls[name].value) {
        formGroup.controls[name].setErrors({ nodata: true });
      }
    });
    return formGroup;
  }

  updateAllComplete() {
    this.RenTMForm.controls.lsp.setValue(
      this.RenTMForm.controls.access.value.every(t => t.value) && this.CustomSubForm.value.every(t => t.value)
    );
  }

  setAll(value: boolean, control = null) {
    if (control === null) {
      this.RenTMForm.controls.lsp.setValue(value);
      if (this.subtasks === null) {
        return;
      }
      this.subtasks.forEach(t => t.value = value);
      this.items.forEach(t => t.value = value);
      this.RenTMForm.controls.access.setValue(this.subtasks);
      this.CustomSubForm.setValue(this.items);
    }
  }

}
